import React from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../../../components/Icons/CloseIcon';
import { ICargoDetailResponse } from '../../../models/home/cargoDetails.model';

interface ICargoDetails {
  data?: ICargoDetailResponse;
  onClickHandler: (...args: any[]) => void;
}

const CargoDetails: React.FC<ICargoDetails> = ({ data, onClickHandler }) => {
  return (
    <>
      {data && (
        <Container>
          <SegmentWrapper className="top">
            <HeaderSection>
              Package Details
              <IconWrapper onClick={onClickHandler}>
                <CloseIcon />
              </IconWrapper>
            </HeaderSection>
            <DetailsSection>
              <DetailsHeader>Details</DetailsHeader>
              <ContentRow>
                <div>Air waybill number</div>
                <div>{data.airWayBillNumber}</div>
              </ContentRow>
              <ContentRow>
                <div>Air cargo name</div>
                <div>{data.airCargoName}</div>
              </ContentRow>
              <ContentRow>
                <div>Air cargo type</div>
                <div>{data.airCargoType}</div>
              </ContentRow>
              <ContentRow>
                <div>Arrival terminal</div>
                <div>{data.arrivalTerminal}</div>
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
          <SegmentWrapper>
            <DetailsSection>
              <DetailsHeader>Waybill Details</DetailsHeader>
              <ContentRow>
                <div>Arrival date</div>
                <div>{data.arrivalDate || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Number of items</div>
                <div>{data.numberOfItems}</div>
              </ContentRow>
              <ContentRow>
                <div>Assigned Clearance Agent</div>
                <div>{data.assignedClearanceAgentName || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Cleared At</div>
                <div>{data.createdAt || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>CreatedAt</div>
                <div>{data.createdAt || 'N/A'}</div>
              </ContentRow>
              <ContentRow>
                <div>Weight</div>
                <div>{data.weight || 'N/A'}</div>
              </ContentRow>
            </DetailsSection>
          </SegmentWrapper>
        </Container>
      )}
    </>
  );
};

export default CargoDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  /* border: 2px solid red; */
  width: 100%;
`;

const SegmentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.19rem;
  padding-bottom: 3rem;
  &.top {
    border-bottom: 1px solid ${({ theme }) => theme.palette.brandGrey};
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 2px solid yellow; */
  width: 100%;
  font-size: 1.125rem;
  font-weight: 500;
  color: #1f1f30;
`;

const DetailsSection = styled.div`
  font-size: 0.825rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DetailsHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
  color: ${({ theme }) => theme.palette.blackPrimary};
`;

const ContentRow = styled.div`
  display: flex;
  gap: 7rem;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
